import styled from "styled-components";

export const Block = styled.div`
  margin-left: 20px;
  margin-top: 5px;
  margin-bottom: 5px;
`;
